import { useEffect } from 'react';
import {
  consumeDeepLinkIntent,
  DeepLinkAction,
  DeepLinkIntent,
  storeDeepLinkIntent,
} from '../utils/deepLink';

export const useDeepLinkFulfillment = (
  action: DeepLinkAction,
  onFulfill: (intent: DeepLinkIntent) => void,
  enabled = true
): void => {
  useEffect(() => {
    if (!enabled) {
      return;
    }

    const intent = consumeDeepLinkIntent();
    if (!intent || intent.action !== action) {
      if (intent) {
        storeDeepLinkIntent(intent);
      }
      return;
    }

    requestAnimationFrame(() => {
      onFulfill(intent);
    });
  // onFulfill MUST be stable (wrapped in useCallback) to prevent re-consuming on re-renders.
  }, [action, enabled, onFulfill]);
};
